import { pathOr } from 'ramda'

import {
  defaultPageSize as defaultContactsPageSize,
  getContactsFailure,
  getContactsRequest,
  getContactsSuccess,
} from '@/app/module/contacts/store/actions'
import {
  ACTION_GET_GROUPS_FAILURE,
  ACTION_GET_GROUPS_REQUEST,
  ACTION_GET_GROUPS_SUCCESS,
  ACTION_GROUPS_NAVIGATE,
  ACTION_RESET_GROUPS_QUERY,
  ERROR_GET_GROUPS_ITEM_CONTACTS_SERVER,
  ERROR_GET_GROUPS_SERVER,
} from '@/app/module/groups/definitions'
import request from '@/app/module/request'
import { createAsyncActions, preventParallel, toQuery } from '@/app/service/util'
import config from '@/config'

const GROUP_TYPE = pathOr({}, ['modules', 'groups', 'type'], config)

const {
  request: getGroupsRequest,
  success: getGroupsSuccess,
  failure: getGroupsFailure,
} = createAsyncActions({
  request: ACTION_GET_GROUPS_REQUEST,
  success: ACTION_GET_GROUPS_SUCCESS,
  failure: ACTION_GET_GROUPS_FAILURE,
})

export { getGroupsFailure, getGroupsRequest, getGroupsSuccess }

export const getGroups = preventParallel(
  ({ orgId, query = {} }) => `${orgId}-${toQuery(query)}`,
  ({ token, orgId, query = {} }) =>
    (dispatch) => {
      const search = query.searchTerm || query.search
      const q = {
        ...query,
        search,
        type: GROUP_TYPE.type,
      }
      dispatch(getGroupsRequest(q))

      const { page = 1, size } = q

      return request.groups
        .getList({ token, orgId, query: q })
        .then(({ groups = [], total = 0 } = {}) => {
          dispatch(
            getGroupsSuccess({
              values: groups,
              page,
              search,
              size: size || total,
              total,
            }),
          )
        })
        .catch((err) => {
          dispatch(
            getGroupsFailure({
              status: err.status,
              error: err.message,
              message: ERROR_GET_GROUPS_SERVER,
            }),
          )
          return err
        })
    },
)

export const resetGroupsQuery = () => ({
  type: ACTION_RESET_GROUPS_QUERY,
})

export const getGroupContacts =
  ({ token, orgId, groupId, query }) =>
  (dispatch) => {
    const q = {
      ...query,
      type: GROUP_TYPE.type,
    }
    dispatch(getContactsRequest(q))

    const { page = 1, size = defaultContactsPageSize } = q

    return request.groups
      .getContacts({ token, orgId, groupId, query: q })
      .then(({ contacts = [], total, orgTotal }) =>
        dispatch(
          getContactsSuccess({
            values: contacts,
            page: parseInt(page || q.page, 10),
            size: size || defaultContactsPageSize,
            total,
            orgTotal,
            searchTerm: '',
            filter: q.filter,
          }),
        ),
      )
      .catch((err) => {
        dispatch(
          getContactsFailure({
            status: err.status,
            error: err.message,
            message: ERROR_GET_GROUPS_ITEM_CONTACTS_SERVER,
          }),
        )
      })
  }

export const navigateGroups = ({ page = 1, searchTerm }) => ({
  type: ACTION_GROUPS_NAVIGATE,
  value: { page, searchTerm },
})
